import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, model, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrl: './input.component.css',
    standalone: true,
    imports: [CommonModule, FormsModule, InputTextModule, FloatLabelModule],
    animations: [trigger('fadeInOut', [state('void', style({ opacity: 0 })), transition(':enter, :leave', [animate(100)])])]
})
export class InputComponent implements OnInit, OnChanges {
    trim() {
        if (this.valor()) this.valor.set(this.valor().trim());
    }
    //# Si es de tipo number y el min es = 0 no deja colocar los "-"
    replace(input: HTMLInputElement) {
        if (this.tipo == 'number' && this.min >= 0) {
            input.value = input.value.replace(/[^0-9]/g, '');
            this.valor.set(input.value);
        }
        if (this.tipo == 'number' && +input.value > this.max) {
            input.value = this.max.toString();
            this.valor.set(input.value);
        }
    }
    valor = model<any>('');
    @Input() tipo: string = 'text';
    @Input() placeholder: string = 'Inserte placeholder';
    @Input() etiqueta: string = 'Inserte etiqueta';
    @Input() readonly = false;
    @Input() id = '';
    @Input() min!: number;
    @Input() max!: number;
    @Input() maxLength?: number;
    @Input() desactivado: boolean = false;

    ngOnInit() {
        this.syncPasswordMode();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['estricto'] || changes['tipo']) {
            this.syncPasswordMode();
        }
    }
    /** Aplica animaciones */
    show = false;

    /** Si es de tipo contraseña, se pone automáticamente */
    contrasenia = false;
    /** Los íconos del toggle contraseña */
    icons: { icon: string; alt: string }[] = [
        { icon: 'assets/svg/eye-closed.svg', alt: 'Mostrar contraseña' },
        { icon: 'assets/svg/eye.svg', alt: 'Ocultar contraseña' }
    ];
    /** Por defecto el ojo cerrado */
    icon = this.icons[0];

    private syncPasswordMode() {
        if (this.estricto) this.tipo = 'password';
        this.contrasenia = this.tipo == 'password';
    }

    /** Varia los íconos al cambiar el tipo */
    toggleContrasenia() {
        switch (this.icon) {
            case this.icons[0]: {
                this.onToggleContrasenia(1, 'text');
                break;
            }
            case this.icons[1]: {
                this.onToggleContrasenia(0, 'password');
                break;
            }
        }
    }
    /** Helper para modificar el icon */
    private onToggleContrasenia(i: number, tipo: string) {
        this.icon = this.icons[i];
        this.tipo = tipo;
        this.contrasenia = false;
        setTimeout(() => {
            this.contrasenia = true;
            if(this.tipo === 'text') this.passwordVisibilityChange.emit(true); else this.passwordVisibilityChange.emit(false);
        }, 50);
    }

    /** Permite linkear una variable bool, para mostrar los mensajes de error, y dejarlo permanente en
     * caso de ser mas estricto, desaparece solo si el usuario cumple las normas del parent */
    @Input() hardError = false;
    /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
     * ingresa el valor */
    @Input() showError = false;
    /** Definimos un mensaje de error para mostrar */
    @Input() mensajeError = '';

    //! Inicio sección de restricción ------------------>
    @Input() estricto = false;
    //* Validaciones ---------->
    isLength = true;
    hasUpperCase = true;
    hasNumbers = true;
    nonRepetitive = true;
    nonConsecutive = true;
    hasSpecialChar = true;
    //* Validaciones ---------->

    /** Emite el evento de si el string es una cadena de caracteres válida */
    @Output() valido = new EventEmitter<boolean>(false);

    /** Realiza todas las comparaciones para definir si la cadena de string cumple con los requisitos solicitados */
    stringValido(str: string) {
        //? Verifica la longitud mínima
        if (str.length < 8) this.isLength = false;
        else this.isLength = true;
        //? Verifica que haya al menos una letra mayúscula
        const hasUpperCase = /[A-Z]/.test(str);
        if (!hasUpperCase) this.hasUpperCase = false;
        else this.hasUpperCase = true;
        //? Verifica que haya al menos un carácter especial
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const hasSpecialChar = specialCharPattern.test(str);
        if (!hasSpecialChar) this.hasSpecialChar = false;
        else this.hasSpecialChar = true;

        //? Toma los números, y verifica que hayan 4
        const numbers = str.match(/\d/g);
        if (!numbers || numbers.length < 4) this.hasNumbers = false;
        else this.hasNumbers = true;

        //? Verifica que los numero no sean los mismos
        const nonRepetitive = numbers?.filter((n) => n == numbers[0]);
        if (nonRepetitive?.length === numbers?.length) this.nonRepetitive = false;
        else this.nonRepetitive = true;

        //? Verifica que no sean consecutivos
        const consecutive = '1234567890';
        if (numbers) {
            const n = numbers.join('');
            let nInvertido = '';
            for (let i = n.length - 1; i >= 0; i--) {
                nInvertido += n[i];
            }
            const contain = consecutive.includes(n) || consecutive.includes(nInvertido);
            if (contain && numbers.length >= 4) {
                this.nonConsecutive = false;
            } else {
                this.nonConsecutive = true;
            }
        }
        //! Dependiendo del valor final, devuelve si esta correcto o no
        if (this.isLength && this.hasUpperCase && this.hasNumbers && this.nonRepetitive && this.nonConsecutive && this.hasSpecialChar) this.valido.emit(true);
        else this.valido.emit(false);
    }
    //! Fin sección de restricción --------------------->

    @Output() onBlur = new EventEmitter<FocusEvent>();
    /** Emite true si la contraseña está visible (tipo text), false si oculta */
    @Output() passwordVisibilityChange = new EventEmitter<boolean>();
    sendOnBlur(event: FocusEvent) {
        this.onBlur.emit(event);
    }

    isEmpty(v: any): boolean {
        return v === null || v === undefined || (typeof v === 'string' && v.trim() === '');
    }
}
